/**
 * 部門
 */
export class Department {
    /** 部門コード */
    code = ""
    /** 部門名 */
    name = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Department>) {
        Object.assign(this, init)
    }

    /**
     * 複製を作成する
     */
    clone() {
        return new Department(JSON.parse(JSON.stringify(this)));
    }

}
